import api from './api'
import { API_ENDPOINTS } from '../config/api'

let publicCache = null
let publicInflight = null

const posterService = {
  get: async () => {
    const response = await api.get(API_ENDPOINTS.POSTER.GET)
    return response.data
  },
  // Welcome-banner posters [{ img, is_mobile }]. Fetched once and cached:
  // prefetchPublic() runs at app boot, so after login the modal reads them
  // synchronously (peekPublic) and the images are already in the browser cache.
  getPublic: async () => {
    if (publicCache) return publicCache
    publicInflight ||= api.get(API_ENDPOINTS.POSTER.PUBLIC)
      .then((response) => {
        publicCache = Array.isArray(response.data?.data) ? response.data.data : []
        return publicCache
      })
      .finally(() => { publicInflight = null })
    return publicInflight
  },
  peekPublic: () => publicCache,
  prefetchPublic: () => {
    posterService.getPublic()
      .then((list) => list.forEach((p) => { if (p?.img) new Image().src = p.img }))
      .catch(() => {})
  },
  update: async (data) => {
    const response = await api.put(API_ENDPOINTS.POSTER.UPDATE, data)
    return response.data
  },
}

export default posterService
